import dayjs from 'dayjs';

import { intl } from 'i18n';

export const roundSecondsByMinutes = (value: number = 0) => {
  const durationMinutes = Math.floor(dayjs.duration(value, 'seconds').asMinutes());
  return dayjs.duration(durationMinutes, 'minutes').asSeconds();
};

export const getDifferenceTime = (startDate?: string | null, endDate?: string | null) => {
  const diffSeconds = dayjs(endDate).diff(dayjs(startDate).utc(), 's');
  const dur = dayjs.duration(diffSeconds * 1000);

  let result = '';
  result += dur.days() ? `${dur.days()} ${intl.formatMessage({ id: 'days' })} ` : '';
  result += dur.hours() ? `${dur.hours()} ${intl.formatMessage({ id: 'hours' })} ` : '';
  result += dur.minutes() ? `${dur.minutes()} ${intl.formatMessage({ id: 'min' })} ` : '';

  return result;
};
